import App from 'App'
import 'assets/scss/style.scss'
import axios from 'axios'
import { BASE_PATH } from 'config'
import { ConfigProvider } from 'contexts/ConfigContext'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import reportWebVitals from 'reportWebVitals'
import * as serviceWorker from 'serviceWorker'
import { openSnackbarWithError } from 'utils/errors'
import { store } from './store'

axios.defaults.baseURL = process.env.REACT_APP_BASE_API_URL

// add axios interceptors to log error
axios.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        console.error('error with axios', error)
        openSnackbarWithError(error, store.dispatch)
        return Promise.reject(error)
    }
)

// ==============================|| REACT DOM RENDER  ||============================== //
ReactDOM.render(
    <Provider store={store}>
        <ConfigProvider>
            <BrowserRouter basename={BASE_PATH}>
                <App />
            </BrowserRouter>
        </ConfigProvider>
    </Provider>,
    document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
